import axios from 'axios';
import logType from './lookupLogType';
import { logTypeExists } from '../../AuditLogs/utilities';
import { elasticRequest } from '../../../services/elasticService';

export const addLookupLog = async (
  url: string,
  action: string,
  description: string,
  username: string,
  comment: string
) => {
  const typeExists = await logTypeExists(url, 'lookuplogs');
  if (!typeExists) {
    addLookupLogType(url);
  }
  const data = {
    action,
    description,
    username,
    created_date: new Date(),
    comment,
  };
  url = url + 'lookuplogs/default';
  try {
    elasticRequest(url, JSON.stringify(data))
      .then((result) => {
        //console.log('added log type?', JSON.stringify(result));
      })
      .catch(function (error) {
        console.log(error);
      });
  } catch (ex) {
    console.log(ex);
  }
};

export const addLookupLogType = (url: string) => {
  url = url + 'logtype/default';
  try {
    elasticRequest(url, JSON.stringify(logType))
      .then((result) => {
        //console.log('added log type?', JSON.stringify(result));
      })
      .catch(function (error) {
        console.log(error);
      });
  } catch (ex) {
    console.log(ex);
  }
};
